export default __webpack_public_path__ + "static/media/burn.9cfe6c30.svg";